import React from 'react';

const DEFAULT_STATE = {};

export const ConfirmarEntrarEmContatoModalContext = React.createContext(
  DEFAULT_STATE
);
